import { PdpProduct } from "@jog/types"

import { convertCentsToEuros, getGtmIdFromCT } from "../helper"
import { gtmPush } from "./index"

export const gtmPdpProductData = (pdpData: PdpProduct, gtmId: string, category: string) => {
    const price = pdpData?.price?.centAmount
    const product = {
        name: pdpData.name?.en || "missing name",
        id: gtmId || "missing id",
        price: price ? parseFloat(convertCentsToEuros(pdpData.price.centAmount)) : "missing price",
        brand: pdpData.brand || "missing brand",
        category,
        variant: "",
    }
    gtmPush({ event: "productDetail-send", ecommerce: { detail: { products: [product] } } })
}

export const gtmSizeChart = () => gtmPush({ event: "size_chart", eventCategory: "size_chart" })

export const gtmAddPdpProductToCart = (product: PdpProduct, path = "") => {
    gtmPush({
        event: "addToCart",
        ecommerce: {
            currencyCode: "EUR",
            actionfield: { list: path },
            add: {
                products: [
                    {
                        brand: product.brand,
                        category: path,
                        id: getGtmIdFromCT(product.attributes),
                        name: product.name?.en || "",
                        price: parseFloat(convertCentsToEuros(product.price.centAmount)),
                        variant: "",
                        quantity: 1,
                        list: "",
                    },
                ],
            },
        },
    })
}
